import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useStore } from "../../store";
import useStore2 from "../../store/hook";
import EstimationService from "../../services/estimation/EstimationService";
import { getHighestDamage } from "../../utils/helper";
import { iParts } from "../../services/estimation/EstimationService";
import OdooEstimationService from "../../services/OdooEstimationService";
import { iZuraguData } from "../../store/zuraguSlice";
import ProcessingScreen from "../../components/ProcessingScreen";

const STAGES = [
  "Сэлбэгийн үнийг тодорхойлж байна",
  "Засварын зардлыг тооцоолж байна",
  "Нийт дүнг бэлтгэж байна",
];

const getDetectedDamages = (data: iZuraguData[] | string | null) =>
  Array.isArray(data) ? data : [];

const Calculations = () => {
  const navigate = useNavigate();

  const clearLoading = useStore.useClearLoading();
  const vehicleInfo = useStore2.useVehicleInfo();
  const victim = useStore2.useVictim();
  const zuragu = useStore2.useZuragu();
  const setEstimations = useStore2.useSetEstimations();
  const name = useStore2.useName();

  const [complete, setComplete] = useState(false);

  useEffect(() => {
    const importDate = vehicleInfo?.importDate?.slice(0, 4);
    const parts: iParts[] = [];
    zuragu.forEach((zur) => {
      getDetectedDamages(zur.data).forEach((da) => {
        parts.push({
          className: da.part_class,
          typeOfBreakdown: getHighestDamage(da.damage_class),
        });
      });
    });

    const payload = {
      markName: vehicleInfo?.make || "",
      modelName: vehicleInfo?.model || "",
      buildYear: vehicleInfo?.year.toString() || "",
      importYear: importDate || "",
      cabinNumber: vehicleInfo?.vin || "",
      plateNumber: vehicleInfo?.plateNumber || "",
      phone: victim?.mobile || "",
      firstName: victim?.name || "",
      register: victim?.registryNumber || "",
      parts: parts,
    };

    EstimationService.CalculatePrice(payload).then((response) => {
      clearLoading(false);

      // Үнэлгээ олдоогүй (алдаа, status=false, эсвэл хоосон жагсаалт) тохиолдолд
      // Invoice дээр "Үнэлгээний мэдээлэл олдсонгүй" гэж харуулна
      const estimations =
        response && response.status !== false ? response.data || [] : [];

      setEstimations(estimations);

      if (estimations.length === 0) {
        setComplete(true);
        return;
      }

      OdooEstimationService.save({
        name: name,
        data: estimations.map((item) => ({ ...item, cdn_path: null })),
        user: {
          mobile: victim?.mobile || "",
          registerNumber: victim?.registryNumber || "",
          firstName: victim?.name || "",
          lastName: victim?.lastName || "",
          email: null,
          aisysId: 0,
          insuranceAisysID: 0,
        },
        vehicle: {
          plateNumber: vehicleInfo?.plateNumber || "",
        },
        cdn_path: null,
        zuragu_source: "web",
        price: estimations.reduce(
          (sum, item) =>
            sum +
            (item.spare_parts_price || 0) +
            (item.repair_price || 0) +
            (item.material_price || 0) +
            (item.labor_fee || 0),
          0
        ),
        state: "draft",
      }).finally(() => {
        setComplete(true);
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    zuragu,
    vehicleInfo?.importDate,
    vehicleInfo?.make,
    vehicleInfo?.model,
    vehicleInfo?.plateNumber,
    vehicleInfo?.vin,
    vehicleInfo?.year,
    victim?.mobile,
    victim?.name,
    victim?.registryNumber,
    setEstimations,
  ]);

  const handleDone = useCallback(() => navigate("/invoice"), [navigate]);

  return (
    <ProcessingScreen
      stages={STAGES}
      complete={complete}
      onDone={handleDone}
      media={<img src="/images/load.png" alt="load" className="max-h-[32vh]" />}
    />
  );
};

export default Calculations;
